import { outbrainMixins } from './outbrainPlacementWidgets'
import { styleMixins } from '../../common/ad_ops/styleMixins'
import type { AdPlacement } from '@duplex/common/ad_ops/adPlacementMappings'

export const placementConfigs: Record<string, AdPlacement> = {
  // Homepage placements
  on_newtab_r1_c2: {
    outbrain: {
      ...outbrainMixins.AR_35,
    },
    style: {
      adHeight: 304,
      adWidth: 300,
    },
    taboola: {},
    assertive: {},
  },
  on_newtab_r1_topright: {
    outbrain: {
      ...outbrainMixins.AR_36,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: {},
    assertive: {},
  },
  on_newtab_r2_c1: {
    outbrain: {
      ...outbrainMixins.AR_37,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: {},
    assertive: {},
  },
  on_newtab_r3_right: {
    outbrain: {
      ...outbrainMixins.AR_45,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: {},
    assertive: {},
  },
  on_newtab_r4_c1: {
    outbrain: {
      ...outbrainMixins.AR_44,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: {},
    assertive: {},
  },
  on_newtab_r4_right: {
    outbrain: {
      ...outbrainMixins.AR_44, //TODO: check if this is correct  @alexannmill
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: {},
    assertive: {},
  },
  on_newtab_endless_native: {
    outbrain: {
      ...outbrainMixins.AR_38,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: {},
    assertive: {},
  },
  on_newtab_endless_right: {
    outbrain: {
      ...outbrainMixins.AR_38,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: {},
    assertive: {},
  },
  on_newtab_slider_1: {
    outbrain: {
      ...outbrainMixins.AR_27,
    },
    style: {
      ...styleMixins[304_612],
    },
    taboola: {},
    assertive: {},
  },
  on_newtab_slider_2: {
    outbrain: {
      ...outbrainMixins.AR_27,
    },
    style: {
      ...styleMixins[304_612],
    },
    taboola: {},
    assertive: {},
  },
  // Article page placements
  on_article_siderail: {
    outbrain: {
      ...outbrainMixins.SB_2,
    },
    style: {
      ...styleMixins[600_300],
    },
    taboola: {},
    assertive: {},
  },

  // //Shopping
  // on_shoppingsection_r3_far_right: {
  //   outbrain: {
  //
  //     ...outbrainMixins.AR_36,
  //   },
  //   style: {
  //     ...styleMixins[300_250],
  //   },
  //   taboola: {},
  //   assertive: {},
  // },
  // on_shoppingsection_r2_c2: {
  //   outbrain: {
  //
  //     ...outbrainMixins.AR_36,
  //   },
  //   style: {
  //     ...styleMixins[300_250],
  //   },
  //   taboola: {},
  //   assertive: {},
  // },
}
